/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Currency_Usd3Inputs */

const he_currency_usd3 = /** @type {(inputs: Currency_Usd3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`USD - US Dollar`)
};

const en_currency_usd3 = /** @type {(inputs: Currency_Usd3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`USD - US Dollar`)
};

/**
* | output |
* | --- |
* | "USD - US Dollar" |
*
* @param {Currency_Usd3Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const currency_usd3 = /** @type {((inputs?: Currency_Usd3Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Currency_Usd3Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_currency_usd3(inputs)
	return en_currency_usd3(inputs)
});
export { currency_usd3 as "currency_USD" }